import { render, staticRenderFns } from "./CrearProductoDialog.vue?vue&type=template&id=5fe9ca27"
import script from "./CrearProductoDialog.vue?vue&type=script&lang=js"
export * from "./CrearProductoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports